<template>
    <div :class="activeDarkMode ? 'border-theme-success' : 'border-warning'">
        <custom-switch
            v-model="activeDarkMode"
            aria-label="Change theme"
            @input="onInput"
        >
            <template #circle>
                {{ activeDarkMode ? "🌛" : "🌞" }}
            </template>
        </custom-switch>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    data: () => ({
        activeDarkMode: false
    }),
    computed: {
        ...mapState("control", ["activeDark"])
    },
    beforeMount() {
        this.setInput(this.activeDark);
    },
    methods: {
        ...mapMutations("control", ["UPDATED_ACTIVE_DARK_MODE"]),
        changeColorMode() {
            document.querySelector("#father").classList.toggle("dark-mode");
        },
        onInput() {
            this.changeColorMode();
            this.UPDATED_ACTIVE_DARK_MODE(this.activeDarkMode);
        },
        setInput(value) {
            this.activeDarkMode = !!value;
            if (
                document
                    .querySelector("#father")
                    .classList.contains("dark-mode") !== this.activeDarkMode
            ) {
                this.changeColorMode();
            }
        }
    }
};
</script>

<style scoped>
.border-radius-sw {
    border-radius: 20px;
}
</style>
